<template>
    <div
        v-if="!isEditingAndType($calculatedBy.FORMULA)"
        :class="wrapperClasses"
        class="w-full mx-1 value-field items-center"
    >
        <!-- Value -->
        <span
            v-if="!isEditingAndType($calculatedBy.VALUE)"
            :class="{'font-bold': isBold, 'opacity-0': !_value && !isEditing}"
            class="text-right p-0"
        >
            {{ _value | money }}
        </span>

        <!-- Editing Value -->
        <span v-else-if="isEditingAndType($calculatedBy.VALUE)">
            <input-currency
                v-model="_value"
                :tabindex="tabindex"
                class="px-2 py-1 text-right p-0"
                no-padding
            />
        </span>

        <!-- Separator -->
        <span :class="{'opacity-0': !_value || !_percent}" class="text-gray-400 dark:text-gray-400">|</span>

        <!-- Percent -->
        <span
            v-if="!isEditingAndType($calculatedBy.PERCENT)"
            :class="{'font-bold': isBold, 'opacity-0': !_percent && !isEditing}"
            class="text-gray-700 dark:text-gray-300 whitespace-nowrap p-0"
        >
            {{ _percent | percent }}
        </span>

        <!-- Editing Percent -->
        <span v-else-if="isEditingAndType($calculatedBy.PERCENT)">
            <input-percent
                v-model="_percent"
                :tabindex="tabindex"
                class="px-3 py-1 w-full"
                no-padding
            />
        </span>
    </div>

    <div v-else class="w-full flex justify-center items-center">
        <formula-editor v-model="_formula"/>
    </div>
</template>

<script>
import FormulaEditor from '@/Components/Storemanager/FormulaEditor';

export default {
    components: {FormulaEditor},
    props: {
        value: {
            type: Number | null,
            required: true,
        },
        percent: {
            type: Number | null,
            required: true,
        },
        formula: {
            type: Object | null,
            required: false,
        },
        isFormulaEditable: {
            type: Boolean,
            required: false,
        },
        isEditing: {
            type: Boolean,
            default: false,
        },
        isBold: {
            type: Boolean,
            default: false,
        },
        calculatedBy: {
            type: String,
        },
        tabindex: {
            type: Number,
        },
    },

    computed: {
        _value: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        _percent: {
            get() {
                return this.percent;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        _formula: {
            get() {
                return this.formula;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        wrapperClasses() {
            return this.isEditing ? ['my-1'] : ['my-2'];
        },
    },

    methods: {
        isEditingAndType(calculatedBy) {
            if (calculatedBy === CalculatedBy.FORMULA) {
                return this.isEditing && this.calculatedBy === calculatedBy && this.isFormulaEditable;
            }

            return this.isEditing && this.calculatedBy === calculatedBy;
        },
    },
};
</script>

<style scoped>
.value-field {
    display: grid;
    grid-template-columns: 1fr 1% 1fr;
    gap: 0.4rem;
}
</style>
